module.exports = __webpack_public_path__ + "static/media/carta_21.42326df3.jpg";